/*
 * A fórmula da distribuição mensal, num lugar só.
 *
 * Ela é usada em duas telas — a Distribuição, que planeja, e o Dashboard, que
 * compara o planejado com o realizado. Duplicá-la seria repetir exatamente o
 * erro que causou o bug das datas D-1 nos relatórios: duas implementações da
 * mesma regra, e só uma corrigida quando a regra mudasse.
 */

/**
 * Quanto um pote recebe: o maior entre o percentual da receita e o mínimo
 * garantido, mais o valor fixo.
 *
 * O fixo entra POR FORA do percentual — é por isso que dá para comprometer
 * mais do que a receita mesmo com os percentuais somando menos de 100%.
 */
export function calcularPote(regra, receita) {
  if (!regra) return 0;
  const percentual = ((regra.planned_percentage || 0) / 100) * (receita || 0);
  return Math.max(percentual, regra.planned_minimum || 0) + (regra.planned_fixed || 0);
}

/** A regra tem algum valor definido? Pote sem regra não participa da distribuição. */
export function temRegra(regra) {
  return !!regra && !!(regra.planned_percentage || regra.planned_minimum || regra.planned_fixed);
}
